module.exports = __webpack_public_path__ + "application/templates/default/inner/account/inner/atendimento/atendimento.template.html";